import { ThunkAction } from 'redux-thunk';
import { IGameState } from '../IGameState';
import { Action } from 'redux';
import { PlatformActions } from '../PlatformActions';

export function handleBackPress(): ThunkAction<Promise<void>, IGameState, never, Action> {
    return async () => {
        PlatformActions.showQuitMenu();
    };
}
